module.exports = __webpack_public_path__ + "static/img/ddhzyk-img1.b372bd95.jpg";